import "/app/app/global.css?transform-only";export default "__VITE_CSS_URL__2f6170702f6170702f676c6f62616c2e6373733f7472616e73666f726d2d6f6e6c79__"